import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid-3 gap-sm"
}
const _hoisted_2 = { class: "panel span-2" }
const _hoisted_3 = { value: "" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "panel"
}
const _hoisted_6 = {
  key: 0,
  class: "panel span-3"
}
const _hoisted_7 = {
  key: 1,
  class: "panel span-3"
}

import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Product, useProduct, ProductSubscription, ProductAddon } from '../Product';
import { ErrorBag, handleFormError } from '@/core/common';
import { getValueInUserLanguage, fillContentModels } from '@/core/languageContent';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import PageLayout from '@/core/components/PageLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';
import AppCheck from '@/core/components/form/AppCheck.vue';
import { getAllLanguages, Language } from '@/modules/parameters/Language';
import { getAllMarkets, Market } from '@/modules/parameters/Market';

interface ProductFormProps {
	pageTitle: string;
	product: Product;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductForm',
  props: {
    pageTitle: {},
    product: {}
  },
  emits: [
	'cancel',
	'saved',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { $gettext } = useGettext();
const resource = useProduct();
const store = useStore<AppStore>();
const languages = ref<Language[]>([]);
const markets = ref<Market[]>([]);
const errors = ref<ErrorBag>({});
const data = ref<Partial<ProductSubscription | ProductAddon>>({});
const addons = computed<ProductAddon[]>(() => store.getters.productAddons);
const market = computed({
	get() {
		return data.value.market?.id;
	},
	set(value: number) {
		data.value.market = {
			id: value,
		};
	},
});

// Set data to form on mount and when the prop value changes.
const setData = () => {
	data.value = Object.assign({}, props.product);
	data.value.content = fillContentModels(data.value.content || [], languages.value);

	if ((data.value as Partial<ProductSubscription>).included_addons === undefined) {
		data.value.included_addons = [];
	}
};
onMounted(async () => {
	languages.value = await getAllLanguages();
	markets.value = await getAllMarkets();
	await store.dispatch('loadProducts');
	setData();
});
watch(() => props.product, setData);

const save = async () => {
	errors.value = {};

	const postBody: Product = Object.assign({}, data.value) as Product;
	postBody.market = market.value;

	let promise: Promise<Product>;
	if (props.product?.id) {
		promise = resource.put(props.product.id, postBody);
	} else {
		promise = resource.post(postBody);
	}

	try {
		const response = await promise;

		emit('saved', response);

	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": __props.pageTitle,
    "base-tag": "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, {
    "header-actions": _withCtx(() => [
      _createVNode(AppButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("Avbryt", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Spara", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (data.value.content)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[12] || (_cache[12] = [
                _createTextVNode("Produktinformation", -1)
              ]))])), [
                [_directive_translate]
              ]),
              _createVNode(AppFormGroup, {
                id: "product_sku",
                errors: errors.value.sku,
                label: _unref($gettext)('Artikelnummer')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    id: "product_sku",
                    modelValue: data.value.sku,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.sku) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "product_market",
                errors: errors.value.market,
                label: _unref($gettext)('Marknad')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppSelect, {
                    id: "product_market",
                    modelValue: market.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((market).value = $event)),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_3, [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("(Välj)", -1)
                      ]))])), [
                        [_directive_translate]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markets.value, (market) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: market.id,
                          value: market.id
                        }, _toDisplayString(market.name), 9, _hoisted_4))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "product_price",
                errors: errors.value.price,
                label: _unref($gettext)('Pris (exkl. moms)')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    type: "number",
                    id: "product_price",
                    modelValue: data.value.price,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.price) = $event)),
                    required: "",
                    min: "0",
                    step: "0.01",
                    max: "9999999999999.99"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "product_vat",
                errors: errors.value.vat,
                label: _unref($gettext)('Moms (%)')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    type: "number",
                    id: "product_vat",
                    modelValue: data.value.vat,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.vat) = $event)),
                    required: "",
                    min: "0",
                    step: "1",
                    max: "100"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"])
            ]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: language.id,
                  class: "panel"
                }, [
                  _createElementVNode("h2", null, _toDisplayString(language.name), 1),
                  _createVNode(AppFormGroup, {
                    id: `product_name_${language.id}`,
                    errors: errors.value.name,
                    label: _unref($gettext)('Namn')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        type: "name",
                        id: `product_name_${language.id}`,
                        modelValue: data.value.content[language.id].name,
                        "onUpdate:modelValue": ($event: any) => ((data.value.content[language.id].name) = $event),
                        required: ""
                      }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["id", "errors", "label"])
                ]))
              }), 128)),
              (data.value.type === 'SUBSCRIPTION')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("Tillägg", -1)
                    ]))])), [
                      [_directive_translate]
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addons.value, (addon) => {
                      return (_openBlock(), _createBlock(AppFormGroup, {
                        key: addon.id,
                        id: `product_included_addon:${addon.id}`,
                        label: _unref(getValueInUserLanguage)(addon.content)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(AppCheck, {
                            modelValue: data.value.included_addons,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.included_addons) = $event)),
                            value: addon.id,
                            id: `product_included_addon:${addon.id}`
                          }, null, 8, ["modelValue", "value", "id"])
                        ]),
                        _: 2
                      }, 1032, ["id", "label"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (data.value.type === 'SUBSCRIPTION')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Abonnemang", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _createVNode(AppFormGroup, {
                    id: "product_admins_included",
                    errors: errors.value.admins_included,
                    label: _unref($gettext)('Inkluderade administratörer')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        type: "number",
                        id: "product_admins_included",
                        modelValue: data.value.admins_included,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.value.admins_included) = $event)),
                        required: "",
                        min: "0",
                        step: "1"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "product_languages_included",
                    errors: errors.value.languages_included,
                    label: _unref($gettext)('Inkluderade språk')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        type: "number",
                        id: "product_languages_included",
                        modelValue: data.value.languages_included,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.value.languages_included) = $event)),
                        required: "",
                        min: "0",
                        step: "1"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "product_notice_period",
                    errors: errors.value.notice_period,
                    label: _unref($gettext)('Uppsägningsperiod')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        type: "number",
                        id: "product_notice_period",
                        modelValue: data.value.notice_period,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.value.notice_period) = $event)),
                        min: "1",
                        step: "1"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"])
                ]))
              : (data.value.type === 'ADDON')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("Tillägg", -1)
                    ]))])), [
                      [_directive_translate]
                    ]),
                    _createVNode(AppFormGroup, {
                      id: "product_code",
                      errors: errors.value.code,
                      label: _unref($gettext)('Tilläggskod')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AppInput, {
                          id: "product_code",
                          modelValue: data.value.code,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((data.value.code) = $event)),
                          required: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["errors", "label"])
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})